/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { spendRulesActorAttributesList } from "../funcs/spendRulesActorAttributesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListActorAttributesResult } from "../models/components/listactorattributesresult.js";
import {
  ListSpendRuleActorAttributesRequest,
  ListSpendRuleActorAttributesSecurity,
} from "../models/operations/listspendruleactorattributes.js";
import { unwrapAsync } from "../types/fp.js";
export type SpendRulesActorAttributesQueryData = ListActorAttributesResult;

export function prefetchSpendRulesActorAttributes(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSpendRuleActorAttributesRequest | undefined,
  security?: ListSpendRuleActorAttributesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSpendRulesActorAttributesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSpendRulesActorAttributesQuery(
  client$: GramCore,
  request?: ListSpendRuleActorAttributesRequest | undefined,
  security?: ListSpendRuleActorAttributesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SpendRulesActorAttributesQueryData>;
} {
  return {
    queryKey: queryKeySpendRulesActorAttributes({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function spendRulesActorAttributesQueryFn(
      ctx,
    ): Promise<SpendRulesActorAttributesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(spendRulesActorAttributesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySpendRulesActorAttributes(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "actorAttributes", "list", parameters];
}
